import React, { useEffect, useState } from "react";
import "./nav.css";
import { Link, NavLink } from "react-router-dom";

const TEXTS = {
  es: {
    about: "Sobre mí",
    cv: "CV",
    projects: "Proyectos",
    contact: "Contacto",
  },
  en: {
    about: "About",
    cv: "Resume",
    projects: "Projects",
    contact: "Contact",
  },
};

function Nav() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [lang, setLang] = useState("es");

  const t = TEXTS[lang];

  const toggleMenu = () => setIsMenuOpen((v) => !v);

  // Cerrar menú al cambiar de ruta (mejora UX mobile)
  useEffect(() => {
    const close = () => setIsMenuOpen(false);
    window.addEventListener("hashchange", close);
    return () => window.removeEventListener("hashchange", close);
  }, []);

  return (
    <header className="nav-wrap">
      <nav className="nav-inner card">
        <div className="nav-left">
          <h1 className="nav-title">
            <Link to="/" className="nav-brand">
              Victor Barreto
            </Link>
          </h1>

          <div className="nav-lang">
            <button
              className={`lang-btn ${lang === "es" ? "active" : ""}`}
              onClick={() => setLang("es")}
              aria-label="Cambiar a español"
            >
              ES
            </button>
            <button
              className={`lang-btn ${lang === "en" ? "active" : ""}`}
              onClick={() => setLang("en")}
              aria-label="Switch to English"
            >
              EN
            </button>
          </div>
        </div>

        <button
          className={`nav-burger ${isMenuOpen ? "open" : ""}`}
          onClick={toggleMenu}
          aria-label="Abrir menú"
          aria-expanded={isMenuOpen}
        >
          <span />
          <span />
          <span />
        </button>

        <div className={`nav-links ${isMenuOpen ? "open" : ""}`}>
          <NavLink
            to="/sobre-mi"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
          >
            {t.about}
          </NavLink>
          <NavLink
            to="/cv"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
          >
            {t.cv}
          </NavLink>
          <NavLink
            to="/proyectos"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
          >
            {t.projects}
          </NavLink>
          <NavLink
            to="/contacto"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
          >
            {t.contact}
          </NavLink>
        </div>
      </nav>
    </header>
  );
}

export default Nav;
